/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TApproveTimeLogRequest } from '../models/TApproveTimeLogRequest';
import type { TCharacterPhotoUrl } from '../models/TCharacterPhotoUrl';
import type { TContractSignatureRequest } from '../models/TContractSignatureRequest';
import type { TContractSignatureResponse } from '../models/TContractSignatureResponse';
import type { TDeleteTimeLogResponse } from '../models/TDeleteTimeLogResponse';
import type { TGetHoldingFeeScheduleResponse } from '../models/TGetHoldingFeeScheduleResponse';
import type { TGetPerformerContractResponse } from '../models/TGetPerformerContractResponse';
import type { TListPerformerContractsResponse } from '../models/TListPerformerContractsResponse';
import type { TPerformerContractId } from '../models/TPerformerContractId';
import type { TSendContractEmailRequest } from '../models/TSendContractEmailRequest';
import type { TSendContractEmailResponse } from '../models/TSendContractEmailResponse';
import type { TTimeLogEntryRequest } from '../models/TTimeLogEntryRequest';
import type { TTimeLogEntryResponse } from '../models/TTimeLogEntryResponse';
import type { TUpdateHoldingFeeCycleRequest } from '../models/TUpdateHoldingFeeCycleRequest';
import type { TUpdateHoldingFeeCycleResponse } from '../models/TUpdateHoldingFeeCycleResponse';
import type { TUpdatePerformerContractRequest } from '../models/TUpdatePerformerContractRequest';
import type { TUpdatePerformerContractResponse } from '../models/TUpdatePerformerContractResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformerContractService {
    /**
     * Get PerformerContract by ID
     * @param id
     * @param relations
     * @returns TGetPerformerContractResponse TGetPerformerContractResponse
     * @throws ApiError
     */
    public static getPerformerContract(
        id: TPerformerContractId,
        relations?: string,
    ): CancelablePromise<TGetPerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contracts/{id}',
            path: {
                'id': id,
            },
            query: {
                'relations': relations,
            },
        });
    }
    /**
     * Update PerformerContract
     * @param id
     * @param requestBody
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */
    public static updatePerformerContract(
        id: TPerformerContractId,
        requestBody: TUpdatePerformerContractRequest,
    ): CancelablePromise<TUpdatePerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/contracts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List PerformerContracts with optional filtering
     * @param performerId
     * @param commercialId
     * @param projectId
     * @param limit
     * @param page
     * @param orderAsJsonString
     * @param relations
     * @returns TListPerformerContractsResponse TListPerformerContractsResponse
     * @throws ApiError
     */
    public static listPerformerContracts(
        performerId?: string,
        commercialId?: string,
        projectId?: string,
        limit?: number,
        page?: number,
        orderAsJsonString?: string,
        relations?: string,
    ): CancelablePromise<TListPerformerContractsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contracts',
            query: {
                'performerId': performerId,
                'commercialId': commercialId,
                'projectId': projectId,
                'limit': limit,
                'page': page,
                'orderAsJsonString': orderAsJsonString,
                'relations': relations,
            },
        });
    }
    /**
     * Update Character Photos
     * @param id
     * @param formData
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */
    public static updateCharacterPhotos(
        id: TPerformerContractId,
        formData: {
            characterPhotos: Array<Blob>;
        },
    ): CancelablePromise<TUpdatePerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/contracts/{id}/photos',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get signed character photo URLs
     * @param id
     * @returns TCharacterPhotoUrl TCharacterPhotoUrl[]
     * @throws ApiError
     */
    public static getCharacterPhotos(
        id: TPerformerContractId,
    ): CancelablePromise<Array<TCharacterPhotoUrl>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contracts/{id}/photos',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Finalize a contract (mark as finalized and generate PDF)
     * @param id
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */
    public static finalizeContract(
        id: TPerformerContractId,
    ): CancelablePromise<TUpdatePerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/finalize',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Cancel a contract
     * @param id
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */
    public static cancelContract(
        id: TPerformerContractId,
    ): CancelablePromise<TUpdatePerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/cancel',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Add a time log entry to a contract
     * @param id
     * @param requestBody
     * @returns TTimeLogEntryResponse TTimeLogEntryResponse
     * @throws ApiError
     */
    public static addTimeLog(
        id: TPerformerContractId,
        requestBody: TTimeLogEntryRequest,
    ): CancelablePromise<TTimeLogEntryResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/timelogs',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the holding fee schedule for a contract
     * @param id
     * @returns TGetHoldingFeeScheduleResponse TGetHoldingFeeScheduleResponse
     * @throws ApiError
     */
    public static getHoldingFeeSchedule(
        id: TPerformerContractId,
    ): CancelablePromise<TGetHoldingFeeScheduleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contracts/{id}/holding-fees',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Record a Paid/Waived override for one holding fee cycle
     * @param id
     * @param cycleNumber
     * @param requestBody
     * @returns TUpdateHoldingFeeCycleResponse TUpdateHoldingFeeCycleResponse
     * @throws ApiError
     */
    public static updateHoldingFeeCycle(
        id: TPerformerContractId,
        cycleNumber: number,
        requestBody: TUpdateHoldingFeeCycleRequest,
    ): CancelablePromise<TUpdateHoldingFeeCycleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/contracts/{id}/holding-fees/{cycleNumber}',
            path: {
                'id': id,
                'cycleNumber': cycleNumber,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Send contract via email
     * @param id
     * @param requestBody
     * @returns TSendContractEmailResponse TSendContractEmailResponse
     * @throws ApiError
     */
    public static sendContractEmail(
        id: TPerformerContractId,
        requestBody: TSendContractEmailRequest,
    ): CancelablePromise<TSendContractEmailResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/send',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Download contract PDF
     * @param id
     * @returns string PDF buffer
     * @throws ApiError
     */
    public static downloadContractPdf(
        id: TPerformerContractId,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contracts/{id}/download',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Sign a contract with performer's signature
     * @param id
     * @param requestBody
     * @returns TContractSignatureResponse TContractSignatureResponse
     * @throws ApiError
     */
    public static signContract(
        id: TPerformerContractId,
        requestBody: TContractSignatureRequest,
    ): CancelablePromise<TContractSignatureResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/sign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Time Log
     * @param id Contract ID
     * @param timeLogId Time Log ID to delete
     * @returns TDeleteTimeLogResponse Success response
     * @throws ApiError
     */
    public static deleteTimeLog(
        id: TPerformerContractId,
        timeLogId: string,
    ): CancelablePromise<TDeleteTimeLogResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/contracts/{id}/timelogs/{timeLogId}',
            path: {
                'id': id,
                'timeLogId': timeLogId,
            },
        });
    }
    /**
     * Approve time log — performer submits initials confirming logged hours are accurate.
     * Transitions contract status to TIME_LOG_APPROVED and writes initials to Text Field28 in the PDF.
     * @param id Contract ID
     * @param requestBody TApproveTimeLogRequest
     * @returns TUpdatePerformerContractResponse Updated contract
     * @throws ApiError
     */
    public static approveTimeLog(
        id: TPerformerContractId,
        requestBody: TApproveTimeLogRequest,
    ): CancelablePromise<TUpdatePerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/approve-time-log',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate a mobile capture token for a contract (authenticated producer).
     * The returned token can be embedded in a QR code so a mobile device can
     * upload character photos without requiring the producer's session.
     * @param id Contract ID
     * @returns any : string }
     * @throws ApiError
     */
    public static generateCaptureToken(
        id: TPerformerContractId,
    ): CancelablePromise<{
        token: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/{id}/capture-token',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Validate a capture token and return contract/performer info.
     * Public endpoint — no auth required. Used by the mobile capture page on load.
     * @param token The capture token
     * @returns any : string; performerName: string }
     * @throws ApiError
     */
    public static validateCaptureToken(
        token: string,
    ): CancelablePromise<{
        performerName: string;
        contractId: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/contracts/capture/{token}',
            path: {
                'token': token,
            },
        });
    }
    /**
     * Upload character photos via capture token (mobile / QR-code flow).
     * Public endpoint — authenticated via the capture token, not a user JWT.
     * @param token The capture token
     * @param formData
     * @returns TUpdatePerformerContractResponse TUpdatePerformerContractResponse
     * @throws ApiError
     */
    public static uploadPhotosWithCaptureToken(
        token: string,
        formData: {
            /**
             * The photo files
             */
            characterPhotos: Array<Blob>;
        },
    ): CancelablePromise<TUpdatePerformerContractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/contracts/capture/{token}/photos',
            path: {
                'token': token,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
